import * as moment from 'moment';
import { Status } from '../../../../shared/enums/status.enum';
import { UtilHelper } from '../../../../shared/helpers/utils.helper';
import { Photo } from '../../../../shared/models/photo.model';
import { Translation } from '../../../../shared/models/translation.model';
import { User } from '../../../../shared/models/user.model';
import { HighlightType } from '../enum/highlight-type.enum';
import { ProductRegisterType } from '../enum/product-register-type.enum';
import { StepStatus } from '../enum/step-status.enum';
import { Complement } from './complement.model';

export class Product {
  id: number;
  categoryId: number;
  name: string;
  type: ProductRegisterType;
  stepStatus: StepStatus;

  // GET: Preço que o back retorna com o menor valor de todos os complementos obrigatórios possíveis.
  // POST: Quando é criado uma promoção, esse campo é enviado como o preço da promoção
  price: number = 0.0; // Obs: 14/12/23 - Esse campo deveria ser apenas GET, e usar o mainPrice nos POST

  mainPrice: number = 0.0; // Usado apenas no GET: Preço do produto, sem complementos
  originalPrice: number; // No POST, é o preço principal do produto.
  description: string;
  servesPeople: number;
  photoBase64: string;
  photoUrl: string;
  complements: Array<Complement>;
  photo: Photo;
  costFrom: boolean;
  order: number;
  status: Status;
  averageRating: number;
  numberReviews: number;
  alcoholic: boolean = false;
  msgError: string;
  delivery: boolean = true;
  localOrder: boolean = true;
  takeaway: boolean = true;
  availabilityControl: boolean;
  quota: number;
  quotaByDay: number; // apenas para referência, não irá decrementar
  startSale: Date | string;
  endSale: Date | string;
  startConsummation: Date | string;
  endConsummation: Date | string;
  externalId: string;
  highlightType: HighlightType;
  placeId: number;
  createdBy: User;
  onlyChangedByCreator: boolean;

  // Aux view
  nameTranslations: Translation;
  descriptionTranslations: Translation;
  bindPlace: boolean;
  promote: boolean;
  limitSalePeriod: boolean;
  periodToConsume: 'SAME' | 'OTHER';
  quotaType: 'STOCK' | 'CAPACITY';

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    //Product type
    if (this.type != null && this.type['code'] == null) {
      this.type = UtilHelper.getEnumByCod(this.type, ProductRegisterType);
    }

    //Status
    if (this.status != null && this.status['code'] == null) {
      this.status = UtilHelper.getEnumByCod(this.status, Status);
    } else if (this.status == null || this.status['code'] == null) {
      this.status = Status.DRAFT;
    }

    if (this.startSale) {
      this.startSale = moment(this.startSale).toDate();
    }
    if (this.endSale) {
      this.endSale = moment(this.endSale).toDate();
    }
    if (this.startConsummation) {
      this.startConsummation = moment(this.startConsummation).toDate();
    }
    if (this.endConsummation) {
      this.endConsummation = moment(this.endConsummation).toDate();
    }

    // Variables to aux view
    this.bindPlace = this.placeId != null;
    this.promote = this.originalPrice != null && this.originalPrice !== this.price;

    if (!this.promote) {
      this.price = this.originalPrice;
    }
    if (!this.quotaType) {
      this.quotaType = this.quotaByDay != null ? 'CAPACITY' : 'STOCK';
    }
    if (this.limitSalePeriod == null) {
      this.limitSalePeriod = this.startSale != null && this.endSale != null;
    }
    if (!this.periodToConsume) {
      this.periodToConsume = this.startConsummation && this.endConsummation ? 'OTHER' : 'SAME';
    }
  }

  toJson(): any {
    if (this.startSale) {
      this.startSale = moment(this.startSale).format('YYYY-MM-DD');
    }
    if (this.endSale) {
      this.endSale = moment(this.endSale).format('YYYY-MM-DD');
    }
    if (this.startConsummation) {
      this.startConsummation = moment(this.startConsummation).format('YYYY-MM-DD');
    }
    if (this.endConsummation) {
      this.endConsummation = moment(this.endConsummation).format('YYYY-MM-DD');
    }
    const data: any = {
      productId: this.id || null,
      categoryId: this.categoryId,
      name: this.name,
      type: this.type['code'],
      price: this.price || 0,
      originalPrice: this.originalPrice || 0,
      stepStatus: this.stepStatus,
      description: this.description,
      servesPeople: this.servesPeople ? Number(this.servesPeople) : null,
      photoBase64:
        this.photoBase64 && this.photoBase64.length > 0 ? this.photoBase64.split(',')[1] : null,
      photoUrl: this.photoUrl,
      status: this.status['code'],
      order: this.order,
      alcoholic: this.alcoholic,
      delivery: this.delivery,
      takeaway: this.takeaway,
      localOrder: this.localOrder,
      availabilityControl: this.availabilityControl || false,
      quota: this.quota != null ? Number(this.quota) : null,
      quotaByDay: this.quotaByDay ? Number(this.quotaByDay) : null,
      highlightType: this.highlightType || null,
      externalId: this.externalId,
      placeId: this.bindPlace ? this.placeId : null,
      startSale: this.startSale,
      endSale: this.endSale,
      startConsummation: this.startConsummation,
      endConsummation: this.endConsummation,
      onlyChangedByCreator: this.onlyChangedByCreator,
    };

    return data;
  }

  toReorderJson(): any {
    const data: any = {
      id: this.id || null,
      order: this.order,
    };
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/models/product.model.ts